var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "live-feeds" },
    [
      _vm.loading
        ? _c("VLoading")
        : !_vm.loading && _vm.cards.length === 0
        ? _c("VEmpty")
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition-group",
        {
          staticClass: "live-feeds-content",
          attrs: { name: "cards", tag: "div" },
        },
        _vm._l(_vm.cards, function (c) {
          return _c(
            "a",
            {
              key: c.id,
              staticClass: "live-card",
              attrs: { target: "_blank", href: c.url },
            },
            [
              _c(
                "div",
                { staticClass: "face-container" },
                [
                  _c("DpiImage", {
                    staticClass: "face",
                    attrs: { size: 48, src: c.upFaceUrl },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "live-info" }, [
                _c(
                  "div",
                  { staticClass: "live-title", attrs: { title: c.title } },
                  [_vm._v(_vm._s(c.title))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "live-name", attrs: { title: c.upName } },
                  [_vm._v(_vm._s(c.upName))]
                ),
              ]),
            ]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }